import React from 'react';
import BackgroundImage from 'gatsby-background-image';

const HeaderImage = ({ imageData, children, className, backgroundPosition }) => {
  return (
    <BackgroundImage
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
        height: '350px',
        backgroundPosition: backgroundPosition || 'center top',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        marginBottom: '40px',
      }}
      className={className}
      fluid={imageData}
    >
      {children}
    </BackgroundImage>
  );
};

export default HeaderImage;
